import request from '@/utils/request';

// 订单售后(后台)
export const orderRefund = (data: any): any =>
  request({
    url: '/order/orderrefund',
    data
  })

// 售后列表(后台)
export const getBackendOrderRefundList = (data: any): any =>
  request({
    url: '/order/backend/refund/list',
    data
  })

// 查看售后详情(后台)
export const getBackendOrderRefundInfo = (data: any): any =>
  request({
    url: '/order/backend/refund/info',
    data
  })

// 补充售后信息
export const setOrderRefundDetail = (data: any): any =>
  request({
    url: '/order/set/refund/detail',
    data
  })

// 售后确认/取消(后台)
export const checkOrderRefund = (data: any): any =>
  request({
    url: '/order/checkorderrefund',
    data
  })

// 订单售后详情(后台)
export const getOrderAfterDetail = (data: any): any =>
  request({
    url: '/order/after/detail',
    data
  })

// 获取供应商售后统计
export const getProviderAfterStatistics = (data: any): any =>
  request({
    url: '/provider/after/statistics',
    data
  })

// 供应商售后确认
export const providerOrderRefund = (data: any): any =>
  request({
    url: '/provider/order/refund',
    data
  })





// 售后单管理
export const orderSupportlist = (data: any): any =>
  request({
    url: '/provider/orderSupport/list',
    data
})
// 售后单管理 确认收货
export const confirmReceiveGoods = (data: any): any =>
  request({
    url: '/provider/orderSupport/confirmReceiveGoods',
    data
})

// 售后单详情
export const orderSupportdetail = (data: any): any =>
  request({
    url: '/provider/orderSupport/detail',
    data
})
// 售后单填写物流
export const orderSupportsendGoods = (data: any): any =>
  request({
    url: '/provider/orderSupport/sendGoods',
    data
})



// 寄回物流单号错误-提醒用户
export const orderSupporterrorReturnExpressNoAlert = (data: any): any =>
  request({
    url: '/provider/orderSupport/errorReturnExpressNoAlert',
    data
})


// 售后单提醒列表-供货商
export const orderSupportremindList = (data: any): any =>
  request({
    url: '/provider/orderSupport/remindList',
    data
})

// 售售后单-修改退款金额
export const orderSupportmodifyRealRefundMoney = (data: any): any =>
  request({
    url: '/provider/orderSupport/modifyRealRefundMoney',
    data
})
// 售后单审核驳回
export const orderSupportcheckReject = (data: any): any =>
  request({
    url: '/provider/orderSupport/checkReject',
    data
})
// 售后单审核通过
export const orderSupportcheckPass = (data: any): any =>
  request({
    url: '/provider/orderSupport/checkPass',
    data
})
// 售后单-修改收款账户
export const orderSupportmodifyAlipayAccount = (data: any): any =>
  request({
    url: '/provider/orderSupport/modifyAlipayAccount',
    data
})
// 售后单-修改退款运费金额(运费险)
export const orderSupportmodifyReturnFreightInsuranceMoney = (data: any): any =>
  request({
    url: '/provider/orderSupport/modifyReturnFreightInsuranceMoney',
    data
})
// 售后单-修改系统备注
export const orderSupportmodifySystemRemark = (data: any): any =>
  request({
    url: '/provider/orderSupport/modifySystemRemark',
    data
})
// 售后单-退款
export const orderSupportrefund = (data: any): any =>
  request({
    url: '/provider/orderSupport/refund',
    data
})
// 售后单-修改系统备注-记录
export const orderSupportmodifySystemRemarkRecordList = (data: any): any =>
  request({
    url: '/provider/orderSupport/modifySystemRemarkRecordList',
    data
})

